import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@progress/kendo-react-common';
import CpsPage from './CpsPage';
import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';
import { RoutePath } from '../types/RoutePath';

const NotExistingPage: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <CpsPage>
      <Typography.h2>{translate('custom.noMatchPage.title')}</Typography.h2>
      <Typography.p>
        <Link to={RoutePath.HOME}>{translate('custom.noMatchPage.description')}</Link>
      </Typography.p>
    </CpsPage>
  );
};

export default NotExistingPage;
